<template>
  <div class="com-box" :class="{'comBoxMargin': creationMode}">
    <div class="lottery-box">
      <span class="label">抽奖样式</span>
      <van-radio-group v-model="form.lotteryMode" direction="horizontal"  icon-size="16px" checked-color="#FF6B31">
        <div class="group-box">
          <div class="img-box">
            <van-image class="img" :src="lottery9" @click="previewImg(1)" />
            <van-radio name="lottery-9">九宫格</van-radio>
          </div>
          <div class="img-box">
            <van-image class="img" :src="turntable" @click="previewImg(2)"/>
            <van-radio name="lottery-turntable">大转盘</van-radio>
          </div>
        </div>
      </van-radio-group>
    </div>
    <van-collapse v-model="activeNames">
      <van-collapse-item
        title="抽奖机会设置"
        name="taskConf1"
        class="collapse-item"
      >
        <van-field
          v-model="form.everyOneMaxWinCount"
          type="digit"
          :maxlength="4"
          label="每人最多可中奖次数"
          label-width="18em"
          input-align="right"
          placeholder="请输入"
          @blur="checkFeeValid('everyOneMaxWinCount')"
        />
        <van-field
          v-model="everyDaySendName"
          label="赠送抽奖机会"
          input-align="right"
          placeholder="请选择"
          is-link
          readonly
          @click="iSgivetype = true"
        >
        </van-field>
        <van-field
          v-model="form.everyDaySendCount"
          type="digit"
          :maxlength="4"
          :label="label"
          input-align="right"
          placeholder="请输入"
          @blur="checkFeeValid('everyDaySendCount')"
        >
          <span slot="right-icon">次抽奖机会</span>
        </van-field>

        <div class="field-item border-bottom">
          <div class="field-item-title bold">
            顾客拉新
            <van-radio-group v-model="form.boolNewPeopleSendCount" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
              <van-radio :name="false">关闭</van-radio>
              <van-radio :name="true">开启</van-radio>
            </van-radio-group>
          </div>
          <span class="tips switch-tips">完成顾客拉新任务获得额外抽奖机会</span>
        </div>
        <template v-if="form.boolNewPeopleSendCount">
          <div class="other">
            <van-field
              v-model="form.everyTimeNewPeopleNumber"
              type="digit"
              :maxlength="4"
              label="邀请新客查看活动,每拉新"
              label-width="12em"
              input-align="center"
              placeholder="请输入"
              @blur="checkFeeValid('everyTimeNewPeopleNumber')"
            >
              <span slot="right-icon">人可获得</span>
            </van-field>
          </div>
          <div class="list">
            <div class="list-other">
              <van-field
                v-model="form.newPeopleSendCount"
                type="digit"
                :maxlength="4"
                input-align="center"
                placeholder="请输入"
                class="other"
                @blur="checkFeeValid('newPeopleSendCount')"
              >
               <span slot="right-icon">次机会,最多送</span>
              </van-field>
            </div>
            <div class="list-other1">
              <van-field
                v-model="form.newPeopleSendTotalCount"
                type="digit"
                :maxlength="4"
                input-align="center"
                placeholder="请输入"
                @blur="checkFeeValid('newPeopleSendTotalCount')"
              >
                <span slot="right-icon">次抽奖机会</span>
              </van-field>
            </div>
          </div>
           <span class="tips">
            <van-icon name="warning-o" />
            第三个空必须是第二个空的倍数
          </span>
        </template>

        <template v-if="isHasSignUp">
          <div class="field-item border-bottom">
            <div class="field-item-title bold">
              报名
              <van-radio-group v-model="form.boolSignUpSendCount" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
                <van-radio :name="false">关闭</van-radio>
                <van-radio :name="true">开启</van-radio>
              </van-radio-group>
            </div>
            <span class="tips switch-tips">完成报名任务获得额外抽奖机会</span>
          </div>
          <van-field
            v-if="form.boolSignUpSendCount"
            v-model="form.signUpSendCount"
            type="digit"
            :maxlength="4"
            label="顾客成功报名活动,可获得"
            label-width="12em"
            input-align="center"
            placeholder="请输入"
            @blur="checkFeeValid('signUpSendCount')"
          >
            <span slot="right-icon">次抽奖机会</span>
          </van-field>
        </template>
        <template v-if="isHasreserve">
          <div class="field-item border-bottom">
            <div class="field-item-title bold">
              直播预约
              <van-radio-group v-model="form.boolLiveReserveSendCount" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
                <van-radio :name="false">关闭</van-radio>
                <van-radio :name="true">开启</van-radio>
              </van-radio-group>
            </div>
            <span class="tips switch-tips">完成直播预约任务获得额外抽奖机会</span>
          </div>
          <van-field
            v-if="form.boolLiveReserveSendCount"
            v-model="form.liveReserveSendCount"
            type="digit"
            :maxlength="4"
            label="顾客成功预约直播,可获得"
            label-width="12em"
            input-align="left"
            placeholder="请输入"
            @blur="checkFeeValid('liveReserveSendCount')"
          >
            <span slot="right-icon">次抽奖机会</span>
          </van-field>
        </template>
        <div class="field-item border-bottom">
          <div class="field-item-title bold">
            屏蔽内部职员
            <van-radio-group v-model="form.boolInternalStaffLimit" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
              <van-radio :name="false">关闭</van-radio>
              <van-radio :name="true">开启</van-radio>
            </van-radio-group>
          </div>
          <span class="tips switch-tips">开启后内部职员将无法中奖</span>
        </div>
      </van-collapse-item>

      <van-collapse-item title="抽奖时间设置" name="taskConf" class="collapse-item">
        <van-field
          v-model="form.lotteryStartDate"
          readonly
          class="text-input"
          label="抽奖开始时间"
          input-align="right"
          placeholder="请选择"
          right-icon="arrow"
          @click="choiceTiem('lotteryStartDate')"
        />
        <van-field
          v-model="form.lotteryEndDate"
          readonly
          label="抽奖截止时间"
          input-align="right"
          placeholder="请选择"
          right-icon="arrow"
          @click="choiceTiem('lotteryEndDate')"
        />
        <van-field
          v-model="form.exchangeEndDate"
          readonly
          label="兑奖截止时间"
          input-align="right"
          placeholder="请选择"
          right-icon="arrow"
          @click="choiceTiem('exchangeEndDate')"
        />
      </van-collapse-item>
    </van-collapse>
    <!-- <van-field name="radio" label="抽奖方式" input-align="right">
      <template #input>
        <van-radio-group v-model="form.lotteryMode" direction="horizontal"  icon-size="16px" checked-color="#FF6B31">
          <van-radio name="lottery-9">九宫格{{form.lotteryMode}}</van-radio>
          <van-radio name="lottery-turntable">大转盘</van-radio>
        </van-radio-group>
      </template>
    </van-field> -->
    <van-popup v-model="isTimePopup" position="bottom" get-container="body">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        title="选择时间"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="confirm"
        @cancel="cancel"
      />
    </van-popup>
    <van-action-sheet
      v-model="iSgivetype"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      get-container="body"
      @cancel="onCancel"
      @select="changeGive"
    />
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import { round2Places } from "@/utils/utils";
import dayjs from "@/utils/dayjs";
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    isHasSignUp: {
      type: Boolean,
      default: false,
    },
    isHasreserve: {
      type: Boolean,
      default: false,
    },
    basicInfoForm: {
      type: Object,
      default() {
        return {};
      },
    },
    from: {
      type: String,
      default: "",
    },
  },
  computed: {
    // 组件创建方式
    creationMode() {
      return this.$route.query.creationMode != 'new' ? true : false
    },
    form: {
      get() {
        // 抽奖时间设置默认值
        if (Object.keys(this.basicInfoForm).length && this.from != "manager" && this.creationMode) {
          let { startTime, endTime } = this.basicInfoForm;
          if (startTime) {
            startTime = startTime.split(" ").length > 1 ? startTime : startTime + " 00:00:00";
            endTime = endTime.split(" ").length > 1 ? endTime : endTime + " 23:59:59";
            this.value.lotteryStartDate = startTime;
            this.value.lotteryEndDate = endTime;
            this.value.exchangeEndDate = endTime;
            let date = endTime.replace(/-/g, "/");
            this.value.exchangeEndDate =  dayjs(new Date(date).getTime() + 86400000).format('YYYY-MM-DD HH:mm:ss');
          }
        }
        return this.value;
      },
      set(newVal) {
        this.$emit("change", newVal);
      },
    },
    everyDaySendName() {
      return this.form.everyDaySendType == 'everyDay' ? '每日赠送' : '一次性赠送'
    },
    label() {
      return this.form.everyDaySendType == 'everyDay' ? '每人每日赠送' : '本场活动赠送'
    }
  },
  data() {
    return {
      activeNames: [],
      iSgivetype: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      isTimePopup: false,
      timeKey: "每人每日赠送",
      actions: [
        {name: '每日赠送',type: 'everyDay',},
        {name: '一次性赠送',type: 'once',},
      ],
      lottery9: 'https://img3.quanyou.com.cn/joyNew/group1/M00/21/FF/rB8LrmVe9TqANKskAAZmFy4EKwY340.png',
      turntable: 'https://img3.quanyou.com.cn/joyNew/group1/M00/21/FE/rB8LrmVe9GiAe0dSAAcJS6QlS5I188.png', 
    }
  },
  methods: {
    onCancel() {
      this.iSgivetype = false
    },
    changeGive(e) {
      this.form.everyDaySendType = e.type
    },
    choiceTiem(key) {
      this.timeKey = key;
      this.isTimePopup = true;
    },
    confirm(e) {
      this.isTimePopup = false;
      this.form[this.timeKey] = dayjs(e).format("YYYY-MM-DD HH:mm:ss");
    },
    cancel() {
      this.isTimePopup = false;
    },
    checkFeeValid(fied) {
      let fieldValue = this.form[fied];
      this.form[fied] = round2Places(fieldValue);
       const {
        everyTimeNewPeopleNumber,
        newPeopleSendCount,
        newPeopleSendTotalCount,
      } = this.form
      if (this.form.boolNewPeopleSendCount) {
        let map = ['everyTimeNewPeopleNumber','newPeopleSendCount','newPeopleSendTotalCount']
        this.form[fied] = this.form[fied] == 0 ? 1 : round2Places(fieldValue);
       
        if (map.includes(fied)) {
          this.form.newPeopleSendMaxCount = ''
          if (!everyTimeNewPeopleNumber || !newPeopleSendCount || !newPeopleSendTotalCount) {
            this.$toast("请完善抽奖机会设置");
          }else if (newPeopleSendTotalCount < newPeopleSendCount || (newPeopleSendTotalCount % newPeopleSendCount) !== 0) {
            this.$toast({
              message: '《顾客拉新》中第三个空必须是第二个空的倍数',
              duration: 3000
            })
          }else {
            this.form.newPeopleSendMaxCount = newPeopleSendTotalCount / newPeopleSendCount
          }
        }
      }
     
    },
    checkValid() {
      const {
        boolNewPeopleSendCount,
        boolSignUpSendCount,
        boolLiveReserveSendCount,
        everyTimeNewPeopleNumber,
        newPeopleSendCount,
        newPeopleSendMaxCount,
        signUpSendCount,
        liveReserveSendCount,
        lotteryStartDate,
        lotteryEndDate,
        exchangeEndDate
      } = this.form
      if (boolNewPeopleSendCount && (!everyTimeNewPeopleNumber || !newPeopleSendCount)) {
        this.$toast("请完善抽奖机会设置");
        return false
      } else if (boolNewPeopleSendCount && !newPeopleSendMaxCount) {
        this.$toast({
          message: '《顾客拉新》中第三个空必须是第二个空的倍数',
          duration: 3000
        })
        return false
      } else if (boolSignUpSendCount && !signUpSendCount) {
        this.$toast("请完善抽奖机会设置");
        return false
      } else if (boolLiveReserveSendCount && !liveReserveSendCount) {
        this.$toast("请完善抽奖机会设置");
        return false
      } else if (!lotteryStartDate || !lotteryEndDate || !exchangeEndDate) {
          this.$toast('请完善抽奖时间配置')
        return false
      }

      let { startTime, endTime } = this.basicInfoForm;
      startTime = (startTime.split(" ").length > 1 ? startTime : startTime + " 00:00:00").replace(/-/g, "/")
      endTime = (endTime.split(" ").length > 1 ? endTime : endTime + " 23:59:59").replace(/-/g, "/")
      // const { lotteryStartDate, lotteryEndDate, exchangeEndDate } = this.form;
      // 解决苹果手机不识别xxxx-xx-xx ss:ss:ss格式
      let startDate = lotteryStartDate.replace(/-/g, "/");
      let endDate = lotteryEndDate.replace(/-/g, "/");
      let exEndDate = exchangeEndDate.replace(/-/g, "/");


      let lotteryStartTime = new Date(startDate).getTime();
      let looteryEndTime = new Date(endDate).getTime();
      let exchangeEndTime = new Date(exEndDate).getTime();
      let activityStartTime = new Date(startTime + "").getTime();
      let activityEenTime = new Date(endTime).getTime();
      if (lotteryStartTime < activityStartTime) {
        this.$toast("抽奖开始时间不能小于活动开始时间");
        return false;
      } else if (lotteryStartTime > activityEenTime) {
        this.$toast("抽奖开始时间不能大于活动结束时间");
        return false;
      } else if (looteryEndTime < lotteryStartTime) {
        this.$toast("抽奖截止时间不能小于抽奖开始时间");
        return false;
      } else if (looteryEndTime > activityEenTime) {
        this.$toast("抽奖截止时间不能大于活动结束时间");
        return false;
      } else if (exchangeEndTime < looteryEndTime) {
        this.$toast("兑奖截止时间不能小于抽奖截止时间");
        return false;
      }
      return true;
    },
    previewImg(type) {
      let images = type == 1 ? this.lottery9 : this.turntable
      ImagePreview({images:[images],closeable: true})
    }
  },
};
</script>

<style lang="stylus" scoped>
.com-box
  .lottery-box {
    display: flex;
    padding: 12px;
    background: #fff;
    .label {
      color: #323233;
      font-weight: bold;
      margin-right: 20px;
    }
    .group-box {
      // flex: 1;
      width: 220px;
      display: flex;
      justify-content: space-between;
      // background: red;
      .img-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        .img {
          width: 60px;
          height: 60px;
          margin-bottom: 10px;
          background: #ccc;
        }
      }
    }
    
  }
  >>> .van-collapse
    border-radius: 8px 8px 0 0
    overflow hidden
  .collapse-item
    >>> .van-collapse-item__title .van-cell__title
      font-weight 600
    >>> .van-collapse-item__content
      padding 0
      .van-cell__title
        color #909399
	>>> .van-field__body input
		color $mainTextColor

.field-item
  // display: flex
  // justify-content: space-between
  // align-items: center
  padding 10px 16px
  font-size 14px
  background-color: #fff
  &-title
    display: flex
    justify-content: space-between
    align-items: center
    color #323233
    font-weight 600
		background: pink;
	.tips {
		color: #999;
		font-size: 10px;
		margin-left: 18px;
    // padding-top: 10px;

	}
  .switch-tips {
    margin-left: 0;
    color: red;
  }
	.list {
		display: flex;
		align-items: center
		>>> .van-cell {
			padding: 2px 16px 10px 16px;
		}
    .list-other {
      >>> .van-cell {
        padding-left: 10px;
        padding-right: 0;
        .van-field__body input {
          border-bottom: 1px solid #909399;
        }
      }
    }
    .list-other1 {
       >>> .van-cell {
        padding-left: 8px;
        .van-field__body input {
          border-bottom: 1px solid #909399;
        }
      }
    }
	}
  .other {
    >>> .van-cell {
      .van-field__body input {
        border-bottom: 1px solid #909399;
      }
    }
  }
	.collapse-title {
		font-size: 14px;
		margin-left: 14px;
		color: #000;
		padding-top: 2px;
	}
  .border-bottom{
    background: #fff;
    border-bottom: 1px solid #f4f4f4;
  }
.comBoxMargin {
  margin: 15px
}
</style>
